
import DefaultController from '../controller';

class Controller extends DefaultController{

    constructor(parent, blueprint={}){

        super(parent, blueprint);
        this.type = 'textbox';
    }
   
    
}

// you can extend a blue print for a parent component by importing it
// and using let Blueprint = Object.assign(parentBlueprint, {my: 'settings'});

let Blueprint = {
    type: Controller,
    properties: { 
        style: {
            display: 'inline-block'
        }
      },
    events: {   },
    children: []
}

export default Blueprint;
export {Controller};
